'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


function cbArticleDirective() {
    return {
        scope: true,
        restrict: 'E',
        transclude: {
            paragraphHeading: '?paragraphHeading',
            paragraphContent: '?paragraphContent'
        },
        template: "<section class=\"article-paragraph__body\">\r\n    <h4 class=\"article-paragraph__title\" data-ng-transclude=\"paragraphHeading\">\r\n        paragraph default heading\r\n    </h4>\r\n    <p class=\"article-paragraph__content\" data-ng-transclude=\"paragraphContent\">\r\n        Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsumLorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum\r\n    </p>\r\n</section>\r\n"
    };
}

exports.default = cbArticleDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/article/cb-article-paragraph.directive.js
// module id = 845
// module chunks = 0